
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { tools } from "src/utils";
import { WechatService, GaodeService } from "src/services";

@Component
export default class CityFilterPage extends Vue {
  // 用于刷新子组件
  private keyNum: any = 0;

  // 样式
  private pageStyle: any = {};

  /**
   * 父组件传值
   * @private
   * @returns object
   */
  @Prop({ type: Object, default: {} })
  private data: {};

  /**
   * 关键字搜索
   * @private
   * @returns number
   */
  private filters: any = {
    key: "",
    cityName: "深圳市",
  };

  /**
   * 是否选择城市弹框
   * @private
   * @returns boolean
   */
  private showCity: boolean = false;

  /**
   * 选中位置
   * @private
   * @returns any
   */
  private get currentLocaltion(): any {
    return this.$store.getters.currentLocaltion;
  }

  /**
   * 当前位置
   * @private
   * @returns any
   */
  private get location(): any {
    return this.$store.getters.location;
  }

  /* 获取当前位置信息
   * @private
   * @returns void
   */
  private async getGeolocation(): Promise<void> {
    this.filters.cityName = this.currentLocaltion || this.location?.city;

    if (localStorage.getItem("location")) {
      return;
    }
    this.$store.dispatch("setLocation", null);
    if (tools.isWechat()) {
      // 如果是微信环境
      this.weixinLocation();
    } else {
      let data = await GaodeService.instance.getBaiduLocation();
      this.$store.dispatch("setLocation", data);
      if (this.location && !this.currentLocaltion) {
        this.filters.cityName = this.location?.city;
      }
    }
  }

  /* 获取当前位置信息 -- 微信
   * @private
   * @returns void
   */
  private async weixinLocation(): Promise<void> {
    let currentUrl = location.href;
    let { content: result } = await WechatService.instance.getWechatJSSDK(currentUrl);
    let loca = await WechatService.instance.getWechatLocation(result); // 获取经纬度-腾讯
    let locat = await GaodeService.instance.getCity((loca as any).longitude, (loca as any).latitude); // 通过经纬度获取城市-高德
    this.$store.dispatch("setLocation", locat);
    if (this.location && !this.currentLocaltion) {
      this.filters.cityName = this.location?.city;
    }
  }

  /*
   * 选择城市
   * @private
   * @returns void
   */
  private onSelectCity(city: string): void {
    this.filters.cityName = city;
    this.showCity = false;
  }

  /*
   * 显示城市组件弹框
   * @private
   * @returns void
   */
  private onShowCityModel(): void {
    this.showCity = true;
  }

  /**
   * 组件创建钩子
   */
  protected created() {
    this.getGeolocation();
  }

  /**
   * 值发生变化
   * @protected
   * @returns void
   */
  @Watch("data", { immediate: true, deep: true })
  private onDataChange(newValue: any): void {
    // 背景样式
    this.pageStyle = {
      margin: newValue.properties.moduleSettings.upAndDown + "px 0 0 0",
      "background-color": newValue.properties.moduleSettings.navigateBgcolor,
    };

    this.keyNum++;
  }
}
